import Vue from 'vue'
import VueRouter from 'vue-router'
import {routes} from "./routes";

Vue.use(VueRouter)

const router = new VueRouter({
    // 跳转路由页面滚到顶部
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    },
    mode: 'history',
    routes
})

/** 解决跳转重复路由报错问题 */
// const routerPush = router.push;
// router.push = path => {
//   if (path === '/medal/wall' && router.currentRoute.fullPath.includes(path + '')) {
//     console.log(1)
//   } else {
//     // 判断下当前路由是否就是要跳转的路由
//     if (router.currentRoute.fullPath.includes(path + '')) return;
//   }
//   return routerPush.call(router, path);
// }

// const whiteList = ['/login', '/noNetwork']
router.beforeEach((to, from, next) => {
    // if (to.path.indexOf('/app/home') !== -1) {
    //   next()
    // } else
    next()
})

export default router
